import { BASE_URL, LOGIN } from "../config";
import { handleResponse } from "./responseHandler";

export async function login(loginData) {
  const response = await fetch(BASE_URL + LOGIN, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(loginData),
  });

  return handleResponse(response);
}
